import { render, staticRenderFns } from "./OptionsmMenu.vue?vue&type=template&id=51690d12&scoped=true&"
import script from "./OptionsmMenu.vue?vue&type=script&lang=js&"
export * from "./OptionsmMenu.vue?vue&type=script&lang=js&"
import style0 from "./OptionsmMenu.vue?vue&type=style&index=0&id=51690d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51690d12",
  null
  
)

export default component.exports